export const sampleDetails = {
    resource_state: "",
    athlete: { id: "", resource_state: 0 },
    name: "",
    distance: 0,
    moving_time: 0,
    elapsed_time: 0,
    total_elevation_gain: 0,
    type: '',
    sport_type: '',
    id: 0,
    start_date: '',
    start_date_local: '',
    timezone: '',
    utc_offset: 0,
    location_city: null,
    location_state: null,
    location_country: null,
    achievement_count: 0,
    kudos_count: 0,
    comment_count: 0,
    athlete_count: 0,
    photo_count: 0,
    map: { id: '', summary_polyline: '', resource_state: 0 },
    trainer: false,
    commute: false,
    manual: false,
    private: false,
    visibility: '',
    flagged: false,
    gear_id: null,
    start_latlng: [],
    end_latlng: [],
    average_speed: 0,
    max_speed: 0,
    has_heartrate: false,
    heartrate_opt_out: false,
    display_hide_heartrate_option: false,
    elev_high: 0,
    elev_low: 0,
    pr_count: 0,
    total_photo_count: 0,
    has_kudoed: false
  }